import { combineReducers } from "redux";
import getBannerSlice from "./getBanner";

const homepageReducer = combineReducers({
  getBannerSlice,
});

export default homepageReducer;
